import React from 'react'
import { Box, Avatar, Typography, Stack, Chip } from '@mui/material'
import { Verified, LocationOn } from '@mui/icons-material'
import { getPhysicianProfileImage } from 'src/pages/Physicians/helpers'
import {
  formatSearchStatus,
  formatYearsExperience,
  getSearchStatusColor,
} from './candidateDisplayHelpers'

const EmployerCandidateHeader = ({ candidate }) => {
  const profileImageUrl = getPhysicianProfileImage(candidate.profileImage)
  const specialty = candidate.specialties?.[0]?.name
  const yearsLabel = formatYearsExperience(candidate.yearsExperience)
  const searchStatusLabel = formatSearchStatus(candidate.searchStatus)
  const searchStatusColor = getSearchStatusColor(candidate.searchStatus)

  const headline = [specialty, yearsLabel ? `${yearsLabel} Years` : null]
    .filter(Boolean)
    .join(' | ')

  return (
    <Box
      sx={{
        width: '100%',
        py: 3,
        textAlign: 'center',
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
      }}
    >
      <Avatar
        src={profileImageUrl}
        sx={{
          width: 96,
          height: 96,
          mx: 'auto',
          mb: 2,
          border: '3px solid',
          borderColor: 'background.paper',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      />

      <Stack
        direction='row'
        spacing={0.5}
        alignItems='center'
        justifyContent='center'
        flexWrap='wrap'
      >
        <Typography variant='h5' fontWeight={700}>
          {candidate.firstName} {candidate.lastName}
        </Typography>
        {candidate.verifiedAt && (
          <Verified sx={{ color: 'primary.main', fontSize: 22 }} />
        )}
      </Stack>

      {headline && (
        <Typography variant='body2' color='text.secondary' sx={{ mt: 0.5 }}>
          {headline}
        </Typography>
      )}

      <Stack
        direction='row'
        spacing={1}
        justifyContent='center'
        flexWrap='wrap'
        gap={1}
        sx={{ mt: 1.5 }}
      >
        {candidate.city && candidate.state && (
          <Chip
            icon={<LocationOn />}
            label={`${candidate.city}, ${candidate.state}`}
            variant='outlined'
            size='small'
          />
        )}
        {searchStatusLabel && (
          <Chip
            label={searchStatusLabel}
            color={searchStatusColor}
            size='small'
            sx={{ fontWeight: 600 }}
          />
        )}
      </Stack>
    </Box>
  )
}

export default EmployerCandidateHeader
